<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap">
      <v-flex class="pa-0 login_content">
        <ValidationObserver ref="observer">
          <v-form
            v-model="valid"
            lazy-validation
          >
            <v-card class="login_form" flat>
              <div class="bg_type">
                <h2 class="top_title d-flex align-center">
                  {{ $t('signin.signin.fields.sign_in') }}
                  <v-spacer></v-spacer>
                  <v-img style="max-width:130px;cursor:pointer;" width="130" src="~@/assets/img/header_logo2.png" alt="EGPO" @click="$router.push('/main')"></v-img>
                </h2>
                <v-card-text class="pa-0 mt-25">
                  <v-row class="ma-0">
                    <!-- E-mail -->
                    <v-col cols="12" class="pa-0 mb-15">

                      <h2 class="title d-flex align-center">
                        {{ $t('signin.signin.fields.email_id') }}
                        <v-spacer></v-spacer>

                        <div class="lang__selector ty2">
                          <v-switch
                            v-model="rtl"
                            color="red"
                            value="red"
                            class=""
                            hide-details
                            @change="fnSetLocale()"
                          ></v-switch>
                          <v-spacer class="hidden_lr5"></v-spacer>
                          <span v-if="rtl">{{ $t('common.common.arabic') }}</span>
                          <span v-else>{{ $t('common.common.english') }}</span>
                        </div>
                      </h2>
                      <ValidationProvider v-slot="{ errors }" name="E-mail" :rules="{required: true, email: true}">
                        <v-text-field
                          v-model="email"
                          placeholder=""
                          solo
                          outlined
                          flat
                          dense
                          clearable
                          :error-messages="errors"
                          append-icon="mdi-alert"
                          class="login_text_filed round5 type_h48 email"
                          ref="email"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>

                    <v-col cols="12" class="pa-0 mb-15 password_box">
                      <h2 class="title">{{ $t('signin.signin.fields.password') }}</h2>
                      <ValidationProvider v-slot="{ errors }" name="Password" :rules="{required: true}">
                        <v-text-field
                          v-model="password"
                          :type="passwordType"
                          label=""
                          solo
                          outlined
                          flat
                          dense
                          clearable
                          :error-messages="errors"
                          append-icon="mdi-alert"
                          class="login_text_filed round5 type_h48"
                          @keyup.enter="fnSignIn()"
                        ></v-text-field>
                        <v-icon class="mdi_eye" @click="fnChangePasswordText()" :class="eye ? 'on': ''">mdi-eye</v-icon>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="mt-0">
                    <v-col cols="12" class="pt-0">
                      <!-- <v-spacer class="hidden_lr20 bar"></v-spacer> -->
                      <v-checkbox v-model="saveIdYn" :value="true" :label="$t('signin.save_id')" class="ft-size12 mt-0"/>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pa-0 mt--5">
                  <v-btn color="white" class="sign_in_btn" text @click="fnSignIn()">{{ $t('signin.signin.fields.sign_in') }}</v-btn>
                </v-card-actions>

                <v-row class="ma-0 mt-15" v-if="otpsmall">
                  <v-btn class="btn_small_text reset_btn" text>{{ $t('signin.signin.fields.reset_google_otp') }}</v-btn>
                </v-row>
                <v-row class="ma-0 mt-15">
                  <v-btn class="btn_small_text forget_btn" text @click="$router.push('/signin/forgotaccount')">{{ $t('signin.signin.fields.forgot_account') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn class="btn_small_text sign up" text @click="$router.push('/signup')">{{ $t('signin.signin.fields.go_signup') }}</v-btn>
                </v-row>
              </div>
            </v-card>
          </v-form>
        </ValidationObserver>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store'
import requestApi from '@/utils/requestApi'
import eventBus from '@/utils/eventBus'
import en from 'vee-validate/dist/locale/en'
import ar from 'vee-validate/dist/locale/ar'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import utils from '@/utils/utils'

export default {
  name: 'SignIn',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      otpsmall : false,
      valid :true,
      flags: false,
      first : [],
      email: '',
      password: '',
      passwordType: 'password',
      eye: false,

      rtl: (store.state.api.language === 'en') ? null: 'red',

      saveIdYn : false,

      return_url : ''
    }
  },
  created () {
  },
  mounted () {
    window.scrollTo(0, 0)
    if(location.href.indexOf(this.$route.path+'?return_url=') > -1){
      this.return_url = decodeURIComponent(location.href.split(this.$route.path+'?return_url=')[1])
    }
    this.$refs.email.focus()
    this.fnGetCookie()
    this.fnCheckIpAddress()
  },
  methods: {
    fnCheckIpAddress() {
      requestApi({
        url: '/config/codes/ipaddress',
        method: 'GET',
        callback: (res) => {
          if (res.res_code !== '200') {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    },
    fnGetCookie(){
      if(this.$cookies.get('SAVE_USER_ID')){
        this.email = this.$cookies.get('SAVE_USER_ID')
        this.saveIdYn = true
      }
    },
    fnSetCookie(){
      this.$cookies.set('SAVE_USER_ID', this.email, '30d')
    },
    fnRemoveCookie(){
      this.$cookies.remove('SAVE_USER_ID')
    },

    fnChangePasswordText() {
      if (this.eye) {
        this.eye = false
        this.passwordType = 'password'
      } else {
        this.eye = true
        this.passwordType = 'text'
      }
    },

    // Sign In 처리
    fnSignIn () {
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          let params = {
            email: this.email,
            password: this.password
          }
          requestApi({
            url: '/autho/user',
            method: 'POST',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                if(this.saveIdYn){
                  this.fnSetCookie()
                }else{
                  this.fnRemoveCookie()
                }

                if (res.data.strong_auth_type_code === '3704') {
                  let nowDate = new Date()
                  nowDate.setMinutes(nowDate.getMinutes() + 10)
                  let option = {
                    text: this.$t('signin.send_otp_email', {time: nowDate.toTimeString().substring(0, 8)})
                  }
                  eventBus.$emit('SHOW_SNACKBAR', option)
                }

                if(utils.isNull(this.return_url)){
                  let options = {
                    name: 'strong-auth-index',
                    params: res.data
                  }
                  this.$router.push(options)
                }else{
                  res.data.return_url = this.return_url
                  let options = {
                    name: 'strong-auth-index-return',
                    params: res.data
                  }
                  this.$router.push(options)
                }

              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          })
        }
      })
    },

    fnSetLocale() {
      if (this.$vuetify.rtl) {
        this.rtl = null
        this.$vuetify.rtl = false
        this.$i18n.locale = 'en'
        this.$vuetify.lang.current = 'en'
        this.$validator.localize('en', en)
        store.dispatch('SetLanguage', 'en')
      } else {
        this.rtl = 'red'
        this.$vuetify.rtl = true
        this.$i18n.locale = 'ar'
        this.$vuetify.lang.current = 'ar'
        this.$validator.localize('ar', ar)
        store.dispatch('SetLanguage', 'ar')
      }
    },
  }
}
</script>

<style lang="less">
</style>
